import { useDispatch, useSelector } from "react-redux";
import { updateFormData } from "../../../../store/slices/currency/currencyRateFormSlice";
import { useEffect } from "react";

const useCurrencyRateForm = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line
  const {
    activeTab,
    CompletedPercentage,
    completedTabs,
    webId,
    selectedItemsDetails,
  } = useSelector((state) => state.currencyRateForm);

  // Only show the Remittance tab when the edit API returned remittance data.
  const hasRemittance =
    selectedItemsDetails !== "" &&
    selectedItemsDetails?.remittance_details != null;

  useEffect(() => {
    dispatch(
      updateFormData((state) => {
        state.activeTab = "Buy";
      })
    );
    //eslint-disable-next-line
  }, []);

  let tabs = [
    { label: "Buy", completed: CompletedPercentage.Buy },
    { label: "Sell", completed: CompletedPercentage.Sale },
    ...(hasRemittance
      ? [{ label: "Remittance", completed: CompletedPercentage.Remittance }]
      : []),
  ];

  const handleTabClick = (tab) => {
    dispatch(
      updateFormData((state) => {
        state.activeTab = tab.label;
      })
    );
  };

  return {
    tabs,
    activeTab,
    webId,
    handleTabClick,
  };
};

export default useCurrencyRateForm;
